require ('../../../commonScript/echartsChina.js');
require ('../../../commonScript/dataHighLight.js');
